
import YCC from "models/ycc";
import { formaTimeToMinute } from "common/js/util";
export default {
  data() {
    return {
      // 易仓储操作人员列表数据
      operatorList: [],
      departmentList: [],
      // 所有选中的操作员id
      allSelectOperatorIds: [],
      // 所有选中的操作员id
      allSelectOperatorIdsCopy: []
    }
  },
  created() {
  },
  methods: {
    // 获取易仓储操作人员列表数据
    initYCCOperatorList(params = {}) {
      YCC.getYCCOperatorList(params).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.name = value.name;
            obj.status = value.status;
            obj.createTime = value.createTime ? formaTimeToMinute(value.createTime) : '/';
            arr.push(obj);
          });
          this.operatorList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    // 获取易仓储部门列表数据
    async initYCCDepartmentList(params = { status: 1 }) {
      let res = await YCC.getYCCDepartmentList(params)
      if (res.success) {
        let arr = [];
        let allSelectOperatorIds = []
        res.result.map((value, index) => {
          let obj = {};
          obj.id = value.id;
          obj.departmentName = value.name;
          let operatorName = ''
          let operators = []
          value.operators.map(i => {
            operatorName += `${i.name};`
            operators.push(i.id)
            allSelectOperatorIds.push(i.id)
          })
          obj.operatorName = operatorName;
          obj.operators = operators;
          arr.push(obj);
        });
        this.allSelectOperatorIds = allSelectOperatorIds
        this.allSelectOperatorIdsCopy = allSelectOperatorIds
        this.departmentList = arr;
      } else {
        this.$message.error(res.message)
      }
    }
  }
}